import React, { useState, useEffect } from "react";
import { PortalComponent, ModalComponent, CardComponent, TableComponent, ButtonIconComponent, SelectComponent, ButtonActionComponent, SwitchComponent } from '../../../components/pages/index'
import { useGetApiWs } from "../../../hooks";
import { api, apiConfig } from "../../../util/api";
import Swal from "sweetalert2";
const AssignCategories = props => {

    const urlCustomer = useGetApiWs('admin', 'entity', 'customer-get');
    const urlCustomerStatus = useGetApiWs('admin', 'entity', 'customer-change-status');
    const urlCategory = useGetApiWs('admin', 'entity', 'category-get');
    const urlCustomerSave = useGetApiWs('admin', 'entity', 'customer-save');
    const urlCustomerDelete = useGetApiWs('admin', 'entity', 'customer-delete');

    const [studies, setStudies] = useState([]);
    const [lbStudy, setLbStudy] = useState(null);
    const [categories, setCategories] = useState([]);
    const [lbCategorie, setLbCategorie] = useState([]);

    const [StudyIsLoading, setStudyIsLoading] = useState(true);
    const [CategoryIsLoading, setCategoryIsLoading] = useState(true);

    const fetchCustomersStudies = async () => {
        const req = await api().post(urlCustomer, { type_info: 'studies', customer_id: props.companyId }, apiConfig());
        var options = req.data.response.map((obj) => {
            var rObj = {};
            rObj['value'] = obj.study_type_id;
            rObj['label'] = obj.study_type_name;
            return rObj;
        });
        setStudies(options);
        setStudyIsLoading(false);
    }

    const fecthCustomerCategories = async (studiesId) => {
        const req = await api().post(urlCustomer, { type_info: `categories`, study_id: studiesId, customer_id: props.companyId }, apiConfig());
        const res = req.data;
        if (res.status === 'success') {
            setTbData(res.response);
        } else {
        }
        setCategoryIsLoading(false);
    }
    const fetchCategoriesLeft = async (studiesId) => {
        const req = await api().post(urlCategory, { customer_id: props.companyId, study_id: studiesId }, apiConfig());
        const res = req.data;
        if (res.status === 'success') {
            var options = res.response.map(obj => {
                var rObj = {};
                rObj['value'] = obj.category_id
                rObj['label'] = obj.name
                return rObj;
            });
            setCategories(options)
        } else {
        }
        setCategoryIsLoading(false);
    }

    const fetchChangeStatus = async (customer_category_id) => {
        const req = await api().post(urlCustomerStatus, { type_info: 'categories', customer_category_id: customer_category_id }, apiConfig());
        const res = req.data;
        if (res.status == 'success') {
            fecthCustomerCategories(lbStudy.value);
            fetchCategoriesLeft(lbStudy.value);
        } else {
        }
    }

    const fetchSave = async () => {
        const req = await api().post(urlCustomerSave, { type_info: 'categories', customer_id: props.companyId, study_id: lbStudy.value, category_id: lbCategorie.value }, apiConfig());
        fecthCustomerCategories(lbStudy.value);
        fetchCategoriesLeft(lbStudy.value);
        setLbCategorie([])
    }

    const fetchDelete = async (customer_category_id) => {
        const req = await api().post(urlCustomerDelete, { type_info: `categories`, customer_category_id: customer_category_id }, apiConfig());
        fecthCustomerCategories(lbStudy.value);
        fetchCategoriesLeft(lbStudy.value);
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Se eliminó correctamente',
            showConfirmButton: false,
            timer: 1000
        })

    }
    const StudyChange = async vals => {
        if (vals === null) {
            setLbStudy(null);
            setCategories([]);
        } else {
            setLbStudy(vals)
            fetchCategoriesLeft(vals.value);
            fecthCustomerCategories(vals.value);
        }
    }

    const CategoryChange = async vals => {
        if (vals === null) {
            setLbCategorie(null)
        } else {
            setLbCategorie(vals);
        }
    }

    const tbColumns = [
        //{ name: 'ID', selector: row => row.customer_category_id,hide:'lg'},
        { name: 'CATEGORIA', selector: row => row.category_name, wrap: true },
        { name: 'PRODUCCIÓN?', button: true, cell: row => <SwitchProduction enabled={row.is_ready_for_report} customer_category_id={row.customer_category_id}></SwitchProduction> },
        { name: 'ELIMINAR', button: true, cell: row => <BtnDelete customer_category_id={row.customer_category_id}></BtnDelete> }
    ]
    const [TbData, setTbData] = useState([]);

    const SwitchProduction = (props) => {
        return (
            <SwitchComponent enabled={(props.enabled == 1) ? true : false} function={() => { fetchChangeStatus(props.customer_category_id) }} />
        )
    }

    const BtnDelete = (props) => {
        return (
            <div>
                <ButtonIconComponent icon="trash" onClick={() => { fetchDelete(props.customer_category_id) }} className="bg-red-500 p-2 m-1 rounded-md text-white"></ButtonIconComponent>
            </div>
        )
    }

    useEffect(() => {
        fetchCustomersStudies();
    }, [])

    return (
        <PortalComponent>
            <ModalComponent header={"ASIGNAR CATEGORIAS"} onCloseModal={props.closeModal}>
                <div className="grid md:grid-cols-2 lg:grid-cols-2 gap-4">
                    <div className="grid grid-cols-1 gap-4 content-start">
                        <SelectComponent label="ESTUDIOS" options={studies} value={lbStudy} onChange={StudyChange} isLoading={StudyIsLoading} />
                        <SelectComponent label="CATEGORIAS RESTANTES" options={categories} value={lbCategorie} onChange={CategoryChange} isLoading={CategoryIsLoading} />
                        <ButtonActionComponent name="AGREGAR" onClick={fetchSave} />
                    </div>
                    <div>
                        <CardComponent header={<h3 className="font-medium" >CATEGORIAS</h3>} footer={null}>
                            <TableComponent keyField="customer_category_id" columns={tbColumns} data={TbData} highlightOnHover={true} />
                        </CardComponent>
                    </div>
                </div>
            </ModalComponent>
        </PortalComponent>
    )
}

export default AssignCategories;